var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-container"},[_c('el-login-form')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }